export const discountStatus = {
    assigned: 1,
    frozen: 2,
    burned: 3,
}

export const getDiscountStatusName = (statusId) => {
    switch (statusId) {
        case discountStatus.assigned: return 'Created';
        case discountStatus.frozen: return 'Frozen';
        case discountStatus.burned: return 'Burnt';
        default: return 'Unknown action';
    }
}
